<template>
  <component
    :is="tag"
    :to="!external ? to : undefined"
    :href="external ? to : undefined"
    :target="external ? '_blank' : undefined"
    :class="{ link: true, 'link--menu': type === 'menu' }"
    :title="
      `${title || ''}${external ? ` (${$MKSlocale['externalLink']})` : ''}`
    "
  >
    <!-- @slot Text of the link-->
    <slot></slot>
  </component>
</template>
<script>
/**
 * Link to internal pages or external pages
 * @version 0.2.0
 */

export default {
  name: "MksLink",
  props: {
    to: {
      type: [String, Object],
      required: true
    },
    /** For usage in the Navigation, adds styling when active link. */
    type: {
      type: String
    },
    /** For accessibility purposes */
    title: {
      type: String
    }
  },
  computed: {
    external() {
      return (
        typeof this.to === "string" &&
        (this.to.startsWith("http") ||
          this.to.startsWith("//") ||
          this.to.startsWith("www") ||
          this.to.startsWith("mailto:"))
      );
    },
    tag() {
      if (this.external) {
        return "a";
      }
      if (!this.$nuxt) {
        return "router-link";
      }
      return "nuxt-link";
    }
  }
};
</script>
<style lang="scss">
.link {
  font-size: inherit;
  font-weight: inherit;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  border-bottom: $border-width-m solid;

  &.exact-active,
  &.router-link-exact-active,
  &.nuxt-link-exact-active {
    color: $color-primary;
    border-color: $color-primary;
  }

  &:focus-visible {
    @include focus($color-primary);
    border-radius: $border-radius-full;
  }

  &--menu {
    font-size: inherit;
    font-weight: inherit;
    border-bottom: none;

    &:hover {
      opacity: $opacity-hover;
    }

    // &.exact-active,
    // &.router-link-exact-active,
    // &.nuxt-link-exact-active {
    //   font-size: inherit;
    //   color: $color-secondary;
    //   position: relative;

    //   &:focus {
    //     @include focus($color-secondary);
    //   }
    // }
  }
}
</style>

